<template>
  <div>
    <div v-if="notfound">
      <img
        src="../../../assets/images/not_found.jpg"
        alt=""
      />
    </div>

    <div v-else>
      <div style="background-color: #0277BD; padding-bottom: 1%">
        <p style="font-size: 28px; color: white; text-align: center; padding-top: 15px">
          ORDER NO. &nbsp;{{ detailData.theOrderID }}
        </p>
      </div>
      <div>
        <div class="col-12 col-xs-12 col-sm-6 col-md-3">
          <h5>
            Order Date: <span style="font-size: 14px">{{ detailData.created_at | moment('YYYY-MM-DD H:mm:ss') }}</span>
          </h5>
        </div>
        <div class="col-12 col-xs-12 col-sm-6 col-md-3">
          <h5>
            Confirm Date: <span style="font-size: 14px">{{ detailData.confirm_date }}</span>
          </h5>
        </div>
        <div class="col-12 col-xs-12 col-sm-6 col-md-3">
          <h5>
            Warehouse Date: <span style="font-size: 14px">{{ detailData.warehouse_date }}</span>
          </h5>
        </div>
        <div class="col-12 col-xs-12 col-sm-6 col-md-3 ">
          <h5>
            Expected Date: <span style="font-size: 14px">{{ detailData.from_date }} - {{ detailData.to_date }}</span>
          </h5>
        </div>
      </div>
      <div
        style="padding-top: 5%; padding-bottom: 2%"
        class="theStepper"
      >
        <v-stepper
          alt-labels
          v-model="currentStep"
          vertical
        >
          <v-stepper-header>
            <v-stepper-step :complete="currentStep >= 0">Requested</v-stepper-step>
            <v-divider class="divider"></v-divider>
            <v-stepper-step
              v-if="isCanceled && currentStep == 1"
              :rules="[() => false]"
            >
              Canceled
            </v-stepper-step>
            <v-divider
              class="divider"
              v-if="isCanceled && currentStep == 1"
            ></v-divider>
            <v-stepper-step :complete="currentStep >= 2">Processed</v-stepper-step>
            <v-divider class="divider"></v-divider>
            <v-stepper-step
              v-if="isCanceled && currentStep == 3"
              :rules="[() => false]"
            >
              Canceled
            </v-stepper-step>
            <v-divider
              class="divider"
              v-if="isCanceled && currentStep == 3"
            ></v-divider>
            <v-stepper-step :complete="currentStep >= 4">Approved</v-stepper-step>
            <v-divider class="divider"></v-divider>
            <v-stepper-step
              v-if="isRefunded && currentStep == 5"
              :rules="[() => false]"
            >
              Refunded
            </v-stepper-step>
            <v-divider
              class="divider"
              v-if="isRefunded"
            ></v-divider>
            <v-stepper-step :complete="currentStep >= 6">Purchased</v-stepper-step>
            <v-divider class="divider"></v-divider>
            <v-stepper-step :complete="currentStep >= 7">Warehouse Delivered</v-stepper-step>
            <v-divider class="divider"></v-divider>
            <v-stepper-step :complete="currentStep >= 8">Int. Shipping</v-stepper-step>
            <v-divider class="divider"></v-divider>
            <v-stepper-step :complete="currentStep >= 9">Pending to Branch</v-stepper-step>
            <v-divider class="divider"></v-divider>
            <v-stepper-step :complete="currentStep >= 10">Arrived to branch</v-stepper-step>
            <v-divider class="divider"></v-divider>
            <v-stepper-step :complete="currentStep == 11">Delivered</v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </div>

      <div
        class="d-inline-block"
        style="margin-left: 25%"
      >
        <div
          class="d-inline mx-3"
          style="vertical-align: bottom"
        >
          <a
            @click="approvingOrder(detailData.order_id)"
            tooltip="Approve this order"
            :class="currentStep == 2 ? '' : 'disabled'"
          >
            <i
              class="fa fa-check-circle"
              :style="currentStep == 2 ? 'color: green; font-size:36px; ' : 'color: grey; font-size:36px; '"
            />
          </a>
        </div>

        <div
          class="d-inline mx-3"
          style="vertical-align: bottom"
        >
          <a
            @click="cancelingOrder(detailData.order_id)"
            tooltip="Cancel this order"
            :class="currentStep == 0 || currentStep == 2 ? '' : 'disabled'"
          >
            <i
              class="fa fa-times-circle"
              :style="
            currentStep == 0 || currentStep == 2
              ? 'color:red; font-size:36px; '
              : 'color:grey; font-size:36px;'
          "
            />
          </a>
        </div>

        <div
          v-if="detailData.status == 'delivered' && !detailData.order_delivery"
          class="d-inline mx-3"
        >
          <v-btn
            color="blue--text"
            style="height: auto;"
            depressed
            @click="requestDelivery()"
          >
            Request Delivery
          </v-btn>
        </div>

        <div
          v-if="detailData.status == 'delivered' && detailData.order_delivery && detailData.order_delivery.order_delivery_id"
          class="d-inline mx-3 white--text py-2 px-3"
          :class="{
            'blue lighten-1': detailData.order_delivery.status == 3,
            'green lighten-1': detailData.order_delivery.status == 4,
          }"
          style="border-radius: 6px; vertical-align: super"
        >
          Delivery {{ detailData.order_delivery.status_name }}
        </div>
      </div>

      <div
        class="row mx-0 mt-3"
        v-if="detailData.images && detailData.images.length > 0"
      >
        <div
          class="col-xs-6 col-sm-3 col-md-3 mb-4"
          v-for="(img,i) in detailData.images"
          :key="i"
          style="cursor: pointer"
          @click="showImage(img)"
        >
          <img
            :src="`${$_image_path()}${img.order_image}`"
            alt="Image"
            width="100%"
            height="150px"
            style="border-radius: 4px"
          >
        </div>
      </div>

      <table id="detailTable">
        <tr v-if="detailData.refund_reason != null">
          <td class="price-section">
            <h6><b>Refund reason</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.refund_reason }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.cancel_reason != null">
          <td class="price-section">
            <h6><b>Cancel reason</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.cancel_reason }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Product Name</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.product_name }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Product URL</b></h6>
          </td>
          <td class="price-section1">
            <h6><a
                :href="detailData.product_url"
                target="_blank"
              >Link</a></h6>
          </td>
        </tr>
        <tr v-if="detailData.coupon != null">
          <td class="price-section">
            <h6><b>Coupon</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.coupon }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.coupon != null">
          <td class="price-section">
            <h6><b>Coupon percentage</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.percentage }}%</h6>
          </td>
        </tr>
        <tr v-if="detailData.type != null">
          <td class="price-section">
            <h6><b>Type</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.type }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.color != null">
          <td class="price-section">
            <h6><b>Color</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.color }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.note != null">
          <td class="price-section">
            <h6><b>Note</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.note }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.size != null">
          <td class="price-section">
            <h6><b>Size</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.size }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Delivery type</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.delivery_type }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Quantity</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.quantity }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.item_price != null">
          <td class="price-section">
            <h6><b>Quantity charge</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.quantity_charge }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.item_price != null">
          <td class="price-section">
            <h6><b>Item price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.item_price }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.tax != null">
          <td class="price-section">
            <h6><b>Tax</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.tax }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.national_tax != null">
          <td class="price-section">
            <h6><b>International Tax</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.national_tax }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.item_weight != null">
          <td class="price-section">
            <h6><b>Item weight(LB)</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.item_weight }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.item_type != null">
          <td class="price-section">
            <h6><b>Item type</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.item_type }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.coupon == null && detailData.internal_shipping_handling != null">
          <td class="price-section">
            <h6><b>Shipping price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.internal_shipping_handling }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.coupon != null && detailData.tmp_shipping != null">
          <td class="price-section">
            <h6><b>Shipping price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.tmp_shipping }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.coupon != null && detailData.tmp_shipping != null">
          <td class="price-section">
            <h6><b>Discounted shipping price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.internal_shipping_handling }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.delivery_price != null">
          <td class="price-section">
            <h6><b>Delivery price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.delivery_price }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.kreenex_fee != null">
          <td class="price-section">
            <h6><b>ShipZone fee</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.kreenex_fee }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.insurance != null">
          <td class="price-section">
            <h6><b>Insurance</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.insurance }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.discount != null">
          <td class="price-section">
            <h6><b>Discount</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.discount }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.total_amount != null">
          <td class="price-section">
            <h6><b>Total price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.total_amount }}</h6>
          </td>
        </tr>
      </table>
    </div>

    <v-dialog
      v-model="imageDialog"
      width="500"
    >
      <v-card>
        <img
          :src="`${$_image_path()}${theImg}`"
          alt=""
          width="100%"
        >
      </v-card>
    </v-dialog>

    <approve-order
      :orderId="theOrderId"
      :approveDialog="approveDialog"
      @close="approveDialog = false"
      @resetTable="getOrderDetail()"
    />
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import approveOrder from './approveOrder.vue'

export default {
  components: {
    approveOrder
  },
  created() {
    this.getLoggedInUser()
    if (
      window.location.search.replace('?id=', '') !== null ||
      window.location.search.replace('?id=', '') !== ''
    ) {
      this.theOrderId = Number(window.location.search.replace('?id=', ''))
      this.getOrderDetail()
    }
  },

  mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser()
    }
  },

  data() {
    return {
      theOrderId: '',
      approveDialog: false,
      orderDetailUrl: 'api/customer_order_detail',
      cancelingOrderUrl: 'api/canceling_order',
      detailResults: [],
      loggedInUserData: {},
      currentStep: 0,
      isCanceled: false,
      isRefunded: false,
      notfound: false,
      imageDialog: false,
      theImg: '',
      detailData: {}
    }
  },

  methods: {
    requestDelivery() {
      swal({
        title: 'نرخی گەیاندن بۆ کاڵای ئاسایی بۆ ناو هەولێر ٥٠٠٠ دینار، بۆ دەرەوەی هەولێر ١٠٠٠٠ دینار',
        buttons: true,
        className: 'swal-title-1'
      }).then(canceled => {
        if (canceled) {
          let token = localStorage.getItem('access_token')
          let data = {
            order_id_fk: this.theOrderId
          }

          axios.post('api/order-delivery', data, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(response => {
            this.getOrderDetail()
            swal({
              title: 'Done',
              icon: 'success',
              timer: 1500,
              buttons: false
            })
          }).catch(error => {
            if (error.response) {
              swal('Error', `${error.response.data.message}`, 'error')
            }
          })
        }
      })
    },

    showImage(img) {
      this.theImg = img.order_image
      this.imageDialog = true
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(response => {
        localStorage.setItem('user_data', JSON.stringify(response.data))
      })
    },

    getOrderDetail() {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + this.theOrderId, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          let data = response.data
          this.detailResults = data.data

          this.detailData = this.detailResults[0]
          this.getCurrentStep()
        })
        .catch(error => {
          if (error.response.data.code_status === 404) {
            this.notfound = true
          }
        })
    },

    getCurrentStep(step = this.detailData.status) {
      if (step === 'new_order') {
        this.currentStep = 0
      } else if (
        step === 'canceled' &&
        (this.detailData.item_price == null || this.detailData.item_price === '')
      ) {
        this.currentStep = 1
        this.isCanceled = true
      } else if (step === 'processed_order') {
        this.currentStep = 2
      } else if (
        step === 'canceled' &&
        (this.detailData.item_price != null || this.detailData.item_price !== '')
      ) {
        this.currentStep = 3
        this.isCanceled = true
      } else if (step === 'approved_order') {
        this.currentStep = 4
      } else if (step === 'refunded') {
        this.currentStep = 5
        this.isRefunded = true
      } else if (step === 'purchased') {
        this.currentStep = 6
      } else if (step === 'warehouse_delivered_order') {
        this.currentStep = 7
      } else if (step === 'int_shipment') {
        this.currentStep = 8
      } else if (step === 'pending_to_branch') {
        this.currentStep = 9
      } else if (step === 'branch_delivery') {
        this.currentStep = 10
      } else if (step === 'delivered') {
        this.currentStep = 11
      } else {
        this.currentStep = 11
      }
    },

    cancelingOrder(id) {
      swal({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(canceled => {
        if (canceled) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.cancelingOrderUrl + '/' + id, '', {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.getOrderDetail()
              swal({
                title: 'Done',
                text: 'Order canceled',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    approvingOrder(id) {
      this.theOrderId = id
      this.approveDialog = true
    }
  }
}
</script>

<style scoped>
a.disabled {
  pointer-events: none;
  color: gray;
}

.price-section {
  border-style: solid;
  border-width: 1px;
  width: 230px;
  padding-left: 10px;
}

.price-section1 {
  border-right-style: solid;
  border-bottom-style: solid;
  border-top-style: solid;
  border-width: 1px;
  width: 670px;
  padding-left: 10px;
}

#detailTable {
  width: 700px;
  margin-left: 200px;
  margin-top: 20px;
  margin-bottom: 40px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 1025px) {
  #detailTable {
    margin-left: 0px;
    width: 100%;
  }
  .price-section1 {
    width: 40%;
  }
  .price-section {
    width: 17%;
  }
  .theStepper {
    width: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 15px;
  }
  .divider {
    display: none;
  }
  .steps {
    display: inline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer/orderDetail.vue